import { render, staticRenderFns } from "./AdminGroupSelectionTreeItem.vue?vue&type=template&id=ea9b4b48"
import script from "./AdminGroupSelectionTreeItem.vue?vue&type=script&lang=ts"
export * from "./AdminGroupSelectionTreeItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports